const homeTranslations = {
  welcome: {
    greeting: "صباح الخير",
    title: "مرحبًا بعودتك",
    description:
      "اعتبر كل وجبة بمثابة خطوة نحو التحول، لأن الجسم الأكثر صحة يشعل القدرة على إعادة تشكيل عالمك",
  },
  bodyInfoCard: {
    title: "معلومات الجسم",
    encourage: "أنت قريب جدًا من هدفكl",
  },
  waterInTakeCard: {
    title: "المياه",
  },
  caloriesCard: {
    title: "السعرات الحرارية",
  },
  mealsCard: {
    title: "الوجبات",
  },
  snacksCard: {
    title: "وجبات الخفيفة",
  },
  macrosCard: {
    calories: "السعرات",
    protein: "بروتين",
    carbs: "كارب",
    fats: "الدهون",
  },
  calendar: {
    title: "التقويم",
    actionButton: {
      show: "اظهار",
      hide: "ااخفاء",
    },
  },
  snacks: "سناكس",
  mealsCategories: {
    title: "اختر فئة الوجبات",
    categories: {
      breakfast: "الوجبة الاولي",
      lunch: "الوجبة الثانية",
      dinner: "الوجبة الثالثة",
      snacks: "جميع الوجبات الخفيفة",
    },
  },
  mealOption: {
    choose: "اختر خيارًا واحدًا لـ",
    yummy: "",
    title: "العناصر الغذائية",
    protein: "بروتين",
    carb: "الكربوهيدرات",
    fat: "دهون",
    kcals: "سعرات حرارية",
    mealsCard: {
      actionButton: "اعرض الوجبة",
      video: "طريقة العمل",
    },
  },
};

export default homeTranslations;
